module.exports = __webpack_public_path__ + "static/media/8.9a8e2965.jpg";